// extracted by mini-css-extract-plugin
module.exports = {"resourceCenter":"style__resourceCenter__Bt1qh","resourceTiles":"style__resourceTiles__pcjhq"};